import React, { FC } from 'react';
import { FormControl, FormControlOwnProps, Select as MUISelect, SelectProps } from '@mui/material';

import { ChevronDownIcon } from 'src/shared/components';
import './Select.styles.scss';

interface Props extends Omit<SelectProps<any>, 'label'> {
  label?: string;
  className?: string;
  id?: string;
  _container?: FormControlOwnProps['sx'];
}

export const Select: FC<Props> = ({ label, className, id = undefined, value, children, _container, ...props }) => {
  return (
    <FormControl id={id} className={className} sx={_container}>
      <MUISelect {...props} value={value} IconComponent={ChevronDownIcon}>
        {children}
      </MUISelect>
      {!value?.toString().length && <label className="select-label">{label}</label>}
    </FormControl>
  );
};
